import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import Toast from './Toast';
import * as styles from './ToastContainer.module.scss';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import { UIActions } from '../ui/uiSlice';
import addTestId from '../utils/addTestId';

const ToastContainer = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state) => state.ui.toasts);

  return (
    <div {...addTestId('toast-container')} className={styles.toastContainer}>
      <AnimatePresence initial={false}>
        {toasts.toReversed().map(({ id, render }) => {
          const onDismiss = () => dispatch(UIActions.removeToast(id));

          return (
            <motion.div
              key={id}
              className={classNames(styles.toastOuter)}
              initial={{ opacity: 0, x: '100%' }}
              animate={{ opacity: 1, x: 0 }}
              exit={{
                marginBottom: 0,
                maxHeight: [200, 0],
                overflow: 'hidden',
                opacity: 0,
              }}
              transition={{ duration: 0.25, ease: [0.65, 0.05, 0.35, 1] }}
            >
              {typeof render === 'function' ? (
                render({ onDismiss })
              ) : (
                <Toast onDismiss={onDismiss} {...render} />
              )}
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;
